"use client";

import { useEffect } from "react";
import posthog from "posthog-js";
import { useTranslations } from "next-intl";

import { Button } from "@/components/ui/button";

interface Props {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function LocaleError({ error, reset }: Props) {
  const t = useTranslations("pages.error");

  useEffect(() => {
    posthog.captureException(error, { digest: error.digest });
  }, [error]);

  return (
    <section className="mx-auto flex w-full max-w-3xl flex-col items-center gap-6 px-6 py-16 text-center sm:py-24">
      <h1 className="font-heading text-4xl leading-tight tracking-tight text-ink sm:text-5xl">
        {t("heading")}
      </h1>
      <p className="max-w-xl text-base text-ink-2">{t("body")}</p>
      <Button type="button" onClick={reset} size="lg" className="mt-2">
        {t("retry")}
      </Button>
    </section>
  );
}
